import React, {Component} from 'react';
import { Row, Col, List, Avatar, Icon } from 'antd';
import './UpdateCard.css';
import jsondata from './data_update.json';

class UpdateCard extends Component {

  renderLoading() {
    return <div>Loading...</div>;
  }

  renderPickCardData(cardPick, pick) {
    var cardData = cardPick.filter((x,i)=> x.id===pick);
    return this.renderCardFlat(cardData[0]);
  }
  renderImage(img_url){
    if (img_url){
      return  (<img src={img_url} style={{float:'right', margin:20}} />)
    } else {
     return null
    }
    
  }

  renderCardFlat(cardData){

    return (
      <div style={{marginTop:100}} className="UpdateCard--container img-rounded" id={cardData.id}>
        {this.renderImage(cardData.img_url)}
        <div className="UpdateCard--headline">
          {cardData.headline}
        </div>
        <div className="UpdateCard--subheadline">
          {cardData.subheadline}
        </div>        
        <div className="UpdateCard--byline">
          {cardData.location}
        </div>
        <div className="UpdateCard--description">
          <div dangerouslySetInnerHTML={{__html:cardData.description1}} />
        </div>     
      </div>
    )
  }

  renderCard(cardData){
    return (
      <div className="UpdateCard--container img-rounded">
        <div className="UpdateCard--headline">
          <Icon type="solution" style={{marginRight:15}}/>  {cardData.headline}
        </div>
        <Row>
          <Col style={{float:'left'}}>
          <div className="UpdateCard--image">
            <img alt="placeholder" className="UpdateCard--img-main img-responsive" src="http://via.placeholder.com/400x450/ddd/000?text=UpdateCard" />
            </div>
          </Col>
          <Col>
            <div className="UpdateCard--description">
              <div className="UpdateCard--subheadline">
                  This is our UpdateCard SubHeadline
              </div>
              <div className="UpdateCard--body-text">
                <p>
                Real Time Touch: <b>"the Missing Link in Telemedicine"</b>
                </p>
                <p>
                Seeking partners to develop this innovative mobile health patent in a $500 Million+ dollar growing market. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis vel eos earum possimus. Voluptatum, 
                </p>

                <List
                  itemLayout="horizontal"
                  dataSource={cardData.subarticle}
                  renderItem={item => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={<Avatar icon="solution" />}
                        title={<span className="UpdateCard--list-item-headline">{item.title}</span>}
                        description={item.description}
                      />
                    </List.Item>
                  )}
                />

                <p>
                Seeking partners to develop this innovative mobile health patent in a $500 Million+ dollar growing market. Lorem ipsum dolor sit amet consectetur adipisicing elit. Debitis vel eos earum possimus. Voluptatum, quas eum aut tenetur assumenda dolor molestiae aspernatur veniam vero vitae eius asperiores aperiam et voluptatem?
                </p>
   
              </div>
            </div>            
          </Col>
        </Row> 
      </div>
    )
  }
  
  render(){

    if (!this.props.pick) { 
      return this.renderLoading();
    } else if (this.props.pick){
      return this.renderPickCardData(jsondata,this.props.pick);
    }

  
  }
}

 export default UpdateCard;


// WEBPACK FOOTER //
// ./src/common/Cards/UpdateCard/UpdateCard.js